import { Injectable } from '@angular/core';
import * as SockJS from 'sockjs-client';
import { Client, Message } from '@stomp/stompjs';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  private stompClient: any;
  private connectionStatusSubject: Subject<any> = new Subject<any>();
  public BroadCastMsg = new Subject<any>();

  private client: Client;
  private messageSubject = new Subject<any>();

  public message$ = this.messageSubject.asObservable();
  
  // Track subscriptions for cleanup
  private subscriptions: any[] = [];

  constructor() { }

  private createSockJS(serverUrl: string) {
    return new SockJS(serverUrl, null, {
      transports: ['websocket', 'xhr-streaming', 'xhr-polling']
    });
  }

  userId: any;
  initializeWebSocketConnection(userId: any): Observable<any> {

    // Disconnect any existing connection before creating a new one
    // to prevent multiple active connections pushing duplicate messages
    if (this.stompClient && this.stompClient.active) {
      this.subscriptions.forEach(sub => {
        if (sub && typeof sub.unsubscribe === 'function') sub.unsubscribe();
      });
      this.subscriptions = [];
      this.stompClient.deactivate();
      this.connectionStatusSubject = new Subject<any>();
    }

    const serverUrl = environment.serverAPI9 + "/ws-endpoint";
    this.stompClient = new Client();

    const that = this;
    this.stompClient.configure({
      webSocketFactory: () => this.createSockJS(serverUrl),
      onConnect: (frame: Message) => {
        console.log('Connected to WebSocket:', frame);
        that.subscribeToMessages(userId);
        that.connectionStatusSubject.next(frame);
      }
    });

    this.stompClient.activate();
    return this.connectionStatusSubject.asObservable();
  }

  subscribeToMessages(userId: any) {
    this.userId = userId;
    const subscription = this.stompClient.subscribe(`/user/${userId}/queue/private-messages`, (message: Message) => {
      if (message.body) {
        console.log('Received private message:', message.body);
        this.BroadCastMsg.next(message.body);
        // Process the message as needed
      }
    });
    this.subscriptions.push(subscription);
  }

  sendPrivateMessage() {
    this.stompClient.publish({
      destination: `/app/send-private-message/${this.userId}`,
      body: 'Hello, this is a private message!'
    });
  }

  getObservableMsg = (): Subject<any> => {
    return this.BroadCastMsg;
  }

  disconnect(): void {
    // Unsubscribe all tracked subscriptions
    this.subscriptions.forEach(sub => {
      if (sub && typeof sub.unsubscribe === 'function') {
        sub.unsubscribe();
      }
    });
    this.subscriptions = [];
    
    // Deactivate STOMP client
    if (this.stompClient) {
      this.stompClient.deactivate();
    }
    
    // Deactivate regular client
    if (this.client) {
      this.client.deactivate();
    }
    
    // Do NOT complete subjects, as they are singleton observables used across the app (like in app.component.ts).
    // Completing them will permanently break listeners until a page refresh.
  }


  

    connect(vendorId: string): void {
    const serverUrl = environment.serverAPI8 + "/ws-endpoint";
    this.client = new Client({
      webSocketFactory: () => this.createSockJS(serverUrl),
      reconnectDelay: 5000,
      onConnect: () => {
        this.client.subscribe(`/user/${vendorId}/queue/private-messages`, (message: Message) => {
          const body = JSON.parse(message.body);
          console.log("connected");
          
          this.messageSubject.next(body);
        });
      }
    });

    this.client.activate();
  }

  connectCalls(vendorId: string): void {
    const serverUrl = environment.serverAPI9 + "/ws-endpoint";
    this.client = new Client({
      webSocketFactory: () => this.createSockJS(serverUrl),
      reconnectDelay: 5000,
      onConnect: () => {
        this.client.subscribe(`/user/${vendorId}/queue/private-messages`, (message: Message) => {
          const body = JSON.parse(message.body);
          console.log("connected");
          
          this.messageSubject.next(body);
        });
      }
    });

    this.client.activate();
  }

}

